import { StyleSheet } from 'react-native';

import { isWebResponsive } from '@constants/platform';
import { Colors, Spacing } from '@theme';

export const styles = StyleSheet.create({
  chatButton: {
    marginLeft: isWebResponsive ? 0 : Spacing.SMALL,
    height: 40,
    width: 40,
    borderRadius: isWebResponsive ? 5 : 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chatActiveButton: {
    backgroundColor: Colors.socialBackground,
    borderWidth: 2,
    borderColor: Colors.limeGreen,
  },
  iconSize: {
    height: 24,
  },
});
